import React, { useEffect, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { CircularAvatar, TableHeader } from "../../commons";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import {
  formateDateAndTime,
  isEmailValid,
  reverseDate,
} from "../../../utils/commonFunctions";
import moment from "moment";
import useDebounce from "../../../customHooks/useDebounce";
import { CollapseClose, CollapseOpen } from "../../../assets/images";
import AutoMatedMailData from "./AutoMatedMailData";
import { AUTOMATION_MAIL_HISTORY, EMAIL_HISTORY_LEAD } from "../../../constant/tableHeadersConstants/LeadDirectoryConstants/leadDirectoryListTableHeaders";

type AppProps = {
  toggleModal: () => void;
  modal: boolean;
  data: any;
  leadEmailText: string;
  setLeadEmailText: (data: string) => void;
  handleSendEmail: any;
  setShowIsLeadSendEmail: React.Dispatch<React.SetStateAction<boolean>>;
  setIsEmailError: React.Dispatch<React.SetStateAction<string>>;
  isEmailError: string;
};

const LeadModuleEmailModal = ({
  toggleModal,
  modal,
  data,
  leadEmailText,
  setLeadEmailText,
  handleSendEmail,
  setShowIsLeadSendEmail,
  setIsEmailError,
  isEmailError
}: AppProps) => {
   const [newData,setNewData]=useState<any>([]);
  const handleEmailChange = (data: string) => {
    setIsEmailError("");

    setLeadEmailText(data);
  };

  useEffect(()=>{
    if(data?.length){
      let finalData=data?.map((item:any)=>{
        return {...item,isOpen:false}
        })
        setNewData([...finalData])
    }
    
  },[data])

  const handleAccordian=(id:any)=>{
   let newAccordianData=newData?.map((item:any,index:number)=>{
    if(index===id){
      return {
        ...item,isOpen:!item?.isOpen
      }
    }
    else{
      return item
    }
   }
   )
   setNewData([...newAccordianData])
  }

  useDebounce(
    () => {
      const emailValidation = !isEmailValid(leadEmailText);
      if (emailValidation) {
        setIsEmailError("Email not valid");
      }
    },
    500,
    [leadEmailText]
  );
  return (
    <Modal isOpen={modal} toggle={() => setShowIsLeadSendEmail(true)} size="lg">
      <ModalHeader toggle={toggleModal}>Send Email to Lead </ModalHeader>
      <ModalBody>
        <div className="d-flex align-items-center">
          <div>
            <input
              type="text"
              className={`form-control`}
              name="text"
              value={leadEmailText}
              placeholder="Enter email address"
              autoFocus
              onChange={(e) => handleEmailChange(e.target.value)}
              //   onKeyPress={(e: any) =>
              //     e.key === "Enter" ? handleSubmitComment(e) : null
              //   }
            />
          </div>
          <div>
            <div>
              <Button
                color="primary ml-3"
                onClick={handleSendEmail}
                disabled={!leadEmailText || isEmailError?.length ? true : false}
              >
                Send Email
              </Button>
            </div>
          </div>
        </div>
        {!!isEmailError && (
          <small className="text-danger">{isEmailError}</small>
        )}
        {data?.length ? (
          <p className="mt-3" style={{ fontSize: "17px", fontWeight: 500 }}>
            Email History
          </p>
        ) : (
          ""
        )}
        <div style={{ overflow: "auto", height: "60vh" }} className="mt-3">
          {newData?.length ? (
            <>
              <div className="new-table-style ">
                <table className="table table-bordered thead-light m-0">
                  <thead className="text-start sticky-table-header">
                    <TableHeader tableHeader={EMAIL_HISTORY_LEAD} />
                  </thead>
                  <tbody>
                    {newData?.length > 0 &&
                      newData?.map((el: any,index:number) => {
                        return (
                          <>
                          <tr className="text-left">
                            {EMAIL_HISTORY_LEAD?.length > 0 &&
                              EMAIL_HISTORY_LEAD?.map(
                                (header: TableHeadersType) => {
                                  if (header.value === "") {
                                    return (
                                      <td
                                        style={{ textAlign: "center",width:"40px",borderRight:"none" ,background:el?.automated_mails_data?.length>0 ?"white" : "#f4f6f8" }}
                                        className="data_inside_table"
                                      >
                                        {el?.isOpen ? (
                                          <img
                                            width="20px"
                                            onClick={() => handleAccordian(index)}
                                            style={{ cursor: "pointer" }}
                                            src={CollapseOpen}
                                            className="accordion-arrow"
                                          />
                                        ) : (
                                          <img
                                            width="20px"
                                            onClick={() => el?.automated_mails_data?.length>0 ? handleAccordian(index) : {}}
                                            style={{ cursor: el?.automated_mails_data?.length>0 ? "pointer" : "default"}}
                                            src={CollapseClose}
                                            className="accordion-arrow"
                                          />
                                        )}
                                      </td>
                                    );
                                  } 
                                  else if (header?.value == "Sent To") {
                                    return (
                                      <td className="text-left mt-5 ">
                                        <span>{el?.to_email}</span>
                                      </td>
                                    );
                                  } else if (header?.value == "Sent By") {
                                    return (
                                      <td className="text-left mt-5">
                                        <div
                                          style={{
                                            paddingTop: "1px",
                                            minWidth: "180px",
                                            overflowWrap: "break-word",
                                            lineHeight: "1.5",
                                          }}
                                          className="d-flex align-items-center"
                                        >
                                          <span className="mr-2">
                                            <CircularAvatar
                                              image={
                                                el?.sent_by?.profile_pic
                                                  ?.file_url
                                              }
                                              name={`${
                                                el?.sent_by?.first_name
                                              } ${
                                                el?.sent_by?.last_name
                                                  ? el?.sent_by?.last_name
                                                  : ""
                                              }`}
                                            />
                                          </span>
                                          <span>
                                            {`${el?.sent_by?.first_name} ${
                                              el?.sent_by?.last_name
                                                ? el?.sent_by?.last_name
                                                : ""
                                            }`}
                                          </span>
                                        </div>
                                      </td>
                                    );
                                  } else if (header?.value == "Sent On") {
                                    return (
                                      <td className="text-left mt-5">
                                        <div
                                          style={{
                                            paddingTop: "1px",
                                            minWidth: "180px",
                                            overflowWrap: "break-word",
                                            lineHeight: "1.5",
                                          }}
                                        >
                                          <div
                                            style={{
                                              paddingTop: "1px",
                                              minWidth: "180px",
                                              overflowWrap: "break-word",
                                              lineHeight: "1.5",
                                            }}
                                          >
                                            {reverseDate(
                                              formateDateAndTime(
                                                el?.sent_at
                                              )?.split(" ")?.[0]
                                            )}
                                          </div>
                                          <span className="due-date-text">
                                            {moment
                                              .utc(
                                                formateDateAndTime(
                                                  el?.sent_at
                                                )?.split(" ")?.[1],
                                                "HH:mm"
                                              )
                                              .local()
                                              .format("hh:mm A")}
                                          </span>
                                        </div>
                                      </td>
                                    );
                                  }
                                }
                              )}
                          </tr>
                          <tr >
                           {el?.isOpen ? <td colSpan={4}>
                            <table>
                            <thead >
                              <TableHeader  tableHeader={AUTOMATION_MAIL_HISTORY}/>
                            </thead>
                            <tbody>
                              <AutoMatedMailData
                              data={el?.automated_mails_data}
                              />
                            </tbody>
                          </table></td> : null}
                          </tr>
                          </>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </>
          ) : (
            <div
              style={{ height: "100%" }}
              className="d-flex align-items-center justify-content-center"
            >
              <h1>No Lead Email History Found</h1>
            </div>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default LeadModuleEmailModal;
